import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

/**
 * The router's error element: a render error in any route lands here instead
 * of blanking the page. Answers already given are in IndexedDB, written by app
 * code rather than a Service Worker, so reloading loses nothing.
 */
export function RouteError() {
  const error = useRouteError()
  console.error('[router]', error)

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error)

  return (
    <main className="centered">
      <div className="card">
        <h1>Něco se pokazilo</h1>
        <p className="muted">Stránku se nepodařilo zobrazit. Odpovědi, které už máte, zůstávají uložené v zařízení.</p>
        <p className="small mono">{message}</p>
        <button className="button button--primary" type="button" onClick={() => window.location.reload()}>
          Načíst znovu
        </button>
      </div>
    </main>
  )
}
